export default __webpack_public_path__ + "static/media/047-tent.64e591aa.png";